import { Component, input, output } from '@angular/core';
import { WorkPersonnelFileEntry } from '@work-frontend-monorepo/work-rest-api';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '@work-frontend-monorepo/work-ui/layout';
import { FormatDatePipe } from '@work-frontend-monorepo/work-ui/pipes';
import { ConfirmActionModalDirective } from '@work-frontend-monorepo/work-ui/modals';

@Component({
  selector: 'sfg-app-personaldossier-card',
  templateUrl: './personaldossier-card.component.html',
  styleUrls: ['./personaldossier-card.component.scss'],
  standalone: true,
  imports: [TranslatePipe, ButtonComponent, FormatDatePipe, ConfirmActionModalDirective],
})
export class PersonaldossierCardComponent {
  entry = input.required<WorkPersonnelFileEntry>();
  canEdit = input(false);
  canDelete = input(false);

  editClick = output<WorkPersonnelFileEntry>();
  deleteClick = output<WorkPersonnelFileEntry>();
}
